export const trackConvertGoal = goal => {
  const w = window;
  w._conv_q = w._conv_q || [];

  w._conv_q.push(['triggerConversion', goal]);

  w._conv_q.push(['recheck_goals']);
};